import { useQuery } from "@apollo/client";
import { IconType } from "react-icons";
import LegendDivider from "../../atoms/LegendDivider";
import Typography from "../../atoms/Typography";
import { LegendTitleContainer } from "../../molecules/LegendTitle/style";
import { TrendMetricsCard } from "../TrendMetricsCard";
import { CARE_CATEGORIES, GET_CARE_TREND_METRICS } from "./query";
import { ICareCategories, ICareTrendingMetrics } from "./type";
interface IActivitiesSectionProps {
  legendTitle: string;
  legendIcon: IconType;
}
export const CareTrendMetrics = ({
  legendTitle,
  legendIcon,
}: IActivitiesSectionProps) => {
  const { data: categoriesData } = useQuery<ICareCategories>(CARE_CATEGORIES);

  const { data, loading } = useQuery<ICareTrendingMetrics>(
    GET_CARE_TREND_METRICS,
    {
      variables: {
        cropNutritionId: categoriesData?.category?.find(
          (category) => category.name === "Crop Nutrition"
        )?.id,
        cropProtectionId: categoriesData?.category?.find(
          (category) => category.name === "Crop Protection"
        )?.id,
        seedsId: categoriesData?.category?.find(
          (category) => category.name === "Seeds"
        )?.id,
      },
      skip: !categoriesData,
      fetchPolicy: "network-only",
    }
  );
  const LegendIcon = legendIcon;
  const LegendTitle = (
    <LegendTitleContainer>
      <LegendIcon />
      <Typography variant="h6">{legendTitle}</Typography>
    </LegendTitleContainer>
  );

  return (
    <div className="mt-14" data-cy="care-trend-metrics-section">
      <LegendDivider title={LegendTitle} />
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 w-full gap-11">
        <TrendMetricsCard
          label="Seeds"
          loading={loading}
          tabsNames={["views", "purchase"]}
          defaultValue="views"
          data={{
            views: data?.seedsViewProducts
              .filter((e) => e.count > 0)
              .map((e) => ({
                item: { ...e },
                count: e.count,
              })),
            purchase: data?.seedsPurchaseProducts
              .filter((e) => e.count > 0)
              .map((e) => ({
                item: { ...e },
                count: e.count,
              })),
          }}
        />
        <TrendMetricsCard
          label="Crop Nutrition"
          loading={loading}
          tabsNames={["views", "purchase"]}
          defaultValue="views"
          data={{
            views: data?.cropNutritionViewProducts
              .filter((e) => e.count > 0)
              .map((e) => ({
                item: { ...e },
                count: e.count,
              })),
            purchase: data?.cropNutritionPurchaseProducts
              .filter((e) => e.count > 0)
              .map((e) => ({
                item: { ...e },
                count: e.count,
              })),
          }}
        />
        <TrendMetricsCard
          label="Crop Protection"
          loading={loading}
          tabsNames={["views", "purchase"]}
          defaultValue="views"
          data={{
            views: data?.cropProtectionViewProducts
              .filter((e) => e.count > 0)
              .map((e) => ({
                item: { ...e },
                count: e.count,
              })),
            purchase: data?.cropProtectionPurchaseProducts
              .filter((e) => e.count > 0)
              .map((e) => ({
                item: { ...e },
                count: e.count,
              })),
          }}
        />
      </div>
    </div>
  );
};
